import React, { useEffect, useState } from 'react';
import { User, Layers, Megaphone, Globe2, FileText } from 'lucide-react';
import { api } from './targets/api';

const cls = 'w-full px-3 py-2 border border-slate-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-slate-900';

export const LEAD_SOURCES = ['Referral', 'Website', 'Cold Call', 'Exhibition', 'Existing Customer', 'Tender', 'Social Media', 'Email Campaign', 'Partner / Consultant', 'Other'];

const Field = ({ icon: Icon, label, children }) => (
  <div>
    <label className="block text-sm font-medium text-slate-700 mb-1"><Icon className="w-4 h-4 inline mr-1" />{label}</label>
    {children}
  </div>
);

export const EnquirySalesFields = ({ formData, setFormData, withEnquiry = false }) => {
  const [team, setTeam] = useState([]);
  const [bus, setBus] = useState([]);
  const [companies, setCompanies] = useState([]);
  const [enquiries, setEnquiries] = useState([]);

  useEffect(() => {
    Promise.all([api('/team'), api('/business-units'), api('/companies')])
      .then(([t, b, c]) => { setTeam(t); setBus(b); setCompanies(c); })
      .catch(() => {});
    if (withEnquiry) {
      fetch(`${window.location.origin}/api/sales/enquiries?limit=500`, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } })
        .then(r => r.json()).then(d => setEnquiries(d.enquiries || [])).catch(() => {});
    }
  }, [withEnquiry]);

  const person = team.find(t => t.name === formData.salesperson);
  const sortedBus = [...bus].sort((a, b) => (person?.bu_ids?.includes(b.id) ? 1 : 0) - (person?.bu_ids?.includes(a.id) ? 1 : 0));
  const companyName = (id) => companies.find(c => c.id === id)?.name || '';
  const set = (k) => (e) => setFormData({ ...formData, [k]: e.target.value });

  const pickPerson = (name) => {
    const p = team.find(t => t.name === name);
    const bu_id = formData.bu_id || (p?.bu_ids?.length === 1 ? p.bu_ids[0] : '');
    setFormData({ ...formData, salesperson: name, bu_id });
  };

  const pickEnquiry = (id) => {
    const e = enquiries.find(x => x.id === id);
    setFormData({ ...formData, enquiry_id: id, salesperson: formData.salesperson || e?.salesperson || '', bu_id: formData.bu_id || e?.bu_id || '' });
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-testid="enquiry-sales-fields">
      <Field icon={User} label="Salesperson">
        <select value={formData.salesperson || ''} onChange={e => pickPerson(e.target.value)} className={cls} data-testid="salesperson-select">
          <option value="">Select salesperson</option>
          {team.filter(t => t.active || t.name === formData.salesperson).map(t => <option key={t.id} value={t.name}>{t.name}</option>)}
        </select>
      </Field>
      <Field icon={Layers} label="Business Unit">
        <select value={formData.bu_id || ''} onChange={set('bu_id')} className={cls} data-testid="bu-select">
          <option value="">Select business unit</option>
          {sortedBus.filter(b => b.active || b.id === formData.bu_id).map(b => (
            <option key={b.id} value={b.id}>{b.code ? `${b.code} – ` : ''}{b.name}{companies.length > 1 ? ` (${companyName(b.company_id)})` : ''}</option>
          ))}
        </select>
      </Field>
      {withEnquiry ? (
        <div className="sm:col-span-2">
          <Field icon={FileText} label="Related enquiry (optional)">
            <select value={formData.enquiry_id || ''} onChange={e => pickEnquiry(e.target.value)} className={cls} data-testid="followup-enquiry-select">
              <option value="">Not linked to an enquiry</option>
              {enquiries.map(e => <option key={e.id} value={e.id}>{e.enquiry_no} – {e.company_name}</option>)}
            </select>
          </Field>
        </div>
      ) : (
        <>
          <Field icon={Megaphone} label="Lead Source">
            <select value={formData.source || ''} onChange={set('source')} className={cls} data-testid="source-select">
              <option value="">Select source</option>
              {LEAD_SOURCES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </Field>
          <Field icon={Globe2} label="Business Type">
            <select value={formData.business_type || 'domestic'} onChange={set('business_type')} className={cls} data-testid="business-type-select">
              <option value="domestic">Domestic</option>
              <option value="export">Export</option>
            </select>
          </Field>
        </>
      )}
    </div>
  );
};
